// extracted by mini-css-extract-plugin
export default {"slogan":"style_slogan__k0fVU","sloganSection":"style_sloganSection__olfA1"};